import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-tres',
  templateUrl: './general-tres.component.html',
  styleUrls: ['./general-tres.component.scss']
})
export class GeneralTresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
